
import React from 'react';
import { Typography, Box } from '@mui/material';
import CircularProgressWithLabel from '../utils/CircularProgressWithLabel';
import color from '../utils/Colors';

interface Skill {
  skillName: string;
  registered: number;
  percentage: number;
}

interface SkillCardProps {
  skillName: string;
  registered: number;
  percentage: number;
}

interface SkillPopularityCardProps {
  skills: Skill[];
}

const SkillCard: React.FC<SkillCardProps> = ({ skillName, registered, percentage }) => {
  return (
    <Box sx={{ backgroundColor: color.forthColor, borderRadius: '10px', color: 'white', marginBottom: '10px' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px' }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            {skillName}
          </Typography>
          <Typography variant="body2">{`${registered} Registered`}</Typography>
        </Box>
        <CircularProgressWithLabel 
              circlecolor={color.thirdColor}
              size={40} fontSize={10} textcolor={'white'} value={percentage} />
      </Box>
    </Box>
  );
};

export const SkillPopularityCard: React.FC<SkillPopularityCardProps> = ({ skills }) => {
  return (
    <Box
      sx={{
        backgroundColor: color.firstColor,
        padding: '20px',
        borderRadius: '15px',
        color: 'white',
        width: '300px',
        height: '400px',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '6px',
          height: '20px',
        },
        '&::-webkit-scrollbar-track': {
          background: color.secondColor,
          borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: color.firstColor,
          border: 'solid 1px white',
          borderRadius: '10px',
        },
      }}
    >
      <Typography variant="h5" sx={{ marginBottom: '15px', fontWeight: 'bold' }}>
        Skill Popularity
      </Typography>

      {skills.length === 0 ? (
        <Typography variant="body2">No skill data yet.</Typography>
      ) : (
        skills.map((skill) => (
          <SkillCard
            key={skill.skillName}
            skillName={skill.skillName}
            registered={skill.registered}
            percentage={skill.percentage}
          />
        ))
      )}
    </Box>
  );
};